module.exports = __webpack_public_path__ + "img/upload-cloud.7c228fec.svg";